export class ServerConnectionModel {
    urL_IdentityServerAPIConfig: string;
    urL_AD6APIConfig: string;
    urL_PortalAPIConfig: string;
    urL_VertexAPIConfig: string;
    urL_USIOAPIConfig: string;
    identityServerAPIConnected: boolean;
    identityServerAPIStatusCode: string;
    identityServerAPIAPIError: string;
    aD6APIConnected: boolean;
    aD6APIStatusCode: string;
    aD6APIError: string;
    portalAPIConnected: boolean;
    portalAPIStatusCode: string;
    portalAPIError: string;
    vertexAPIConnected: boolean;
    vertexAPIStatusCode: string;
    vertexAPIError: string;
    usioapiConnected: boolean;
    usioapiStatusCode: string;
    usioapiError: string;
}

export class ServerConnectionAuthModel {
    twilioServerConnected: boolean;
    googleQRGeneratorConnected: boolean;
}